import React from 'react';
import IdentityCard from '../components/IdentityCard';

const CV: React.FC = () => {
  return (
    <div className="App">
      <IdentityCard />
      {/* Hero Section */}
      <section className="hero-section cv-hero-section">
        <div className="container">
          <div className="text-center animate-fade-in-up">
            <h1 className="page-title">Curriculum Vitae</h1>
          </div>
        </div>
      </section>

      {/* CV PDF Display */}
      <section className="section">
        <div className="container">
          <div className="text-center mb-3">
            <a 
              href="/materials/curriculum_vitae.pdf" 
              download="Sanchita_Kamath_CV.pdf"
              className="btn btn-cv-download"
            >
              Download CV
            </a>
          </div>
          
          {/* Embedded PDF */}
          <div className="card">
            <iframe 
              src="/materials/curriculum_vitae.pdf"
              width="100%"
              height="800"
              className="cv-iframe"
              title="Curriculum Vitae"
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default CV;
